export const SvgIconComponent = (props) => {
  return (
    <svg width height viewBox="0 0 28 27" fill="none" {...props}>
      {
        props.path_d.map((path, key) => <path key={key} d={path} fill={props.fill} />)
      }
    </svg>
  );
};
